var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import * as SavvyResultsUI from "../../components/SavvyResultsUI/SavvyResultsUI";
import { InsuranceProducts, InsuranceType } from "../../constants";
import { offerPresented, sawImpression } from "../../lib/Avo";
import Ad from "../../components/Ad/Ad";
import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import EditPolicyButton from "../../features/search/components/EditPolicyButton";
import Header from "../../components/Header";
import HomeBundleItem from "../../features/search/components/HomeBundleItem";
import { ImpressionType } from "../../lib/constants";
import NoQuotes from "../../features/search/components/NoQuotes";
import { PHASE } from "../../routeConfig";
import Quote from "../../components/Quote";
import { ResultType } from "../../services/savvy/constants";
import { SellingPointGroups } from "../../features/search/components/SellingPoints";
import { filterAdResultsForAnalytics } from "../../features/search/utils";
import { getMonthlyAutoPremium } from "../../services/savvy/utils";
import { skipToken } from "@reduxjs/toolkit/query";
import useAppSelector from "../../hooks/useAppSelector";
import { useEffectOnceWhen } from "rooks";
import { useGetSearchResultsQuery } from "../../services/savvy";
import useImpressionType from "../../services/savvy/useImpressionType";
import useIsRemarketingSearch from "../../features/configuration/useIsRemarketingSearch";
import useResultsHeaderText from "../../features/search/useResultsHeaderText";
function getSecondaryText(_a) {
    var didLink = _a.didLink, isBundle = _a.isBundle;
    var output = "Offers are based on";
    if (didLink) {
        output = "".concat(output, " your current policy");
    }
    else {
        output = "".concat(output, " the information you provided");
    }
    if (isBundle) {
        output = "".concat(output, " and include the auto insurance offer selected from the previous page");
    }
    return "".concat(output, ".");
}
export default function HomeOfferListRoute() {
    var _a, _b;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var _c = useAppSelector(function (state) { return state.applicant; }), accountLinked = _c.accountLinked, accountReferenceId = _c.accountReferenceId, insuranceProduct = _c.insuranceProduct, autoIssuerId = _c.bundle.autoIssuerId;
    var isRemarketingSearch = useIsRemarketingSearch();
    var impressionType = useImpressionType();
    var _d = useGetSearchResultsQuery(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            isRemarketingSearch: isRemarketingSearch,
            impressionType: impressionType,
        }
        : skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data, isSuccess = _a.isSuccess;
            var hasProgressiveResult = (data === null || data === void 0 ? void 0 : data.mixedResults.some(function (_a) {
                var quoteContent = _a.quoteContent, adContent = _a.adContent;
                return [quoteContent === null || quoteContent === void 0 ? void 0 : quoteContent.issuerId, adContent === null || adContent === void 0 ? void 0 : adContent.issuerId].includes(AllIssuers.PROGRESSIVE);
            })) ||
                (data === null || data === void 0 ? void 0 : data.bundles.some(function (bundle) { return bundle.home.issuerId === AllIssuers.PROGRESSIVE; })) ||
                false;
            return __assign(__assign({}, data), { homeResults: data === null || data === void 0 ? void 0 : data.bundles.reduce(function (acc, curr) {
                    if (curr.auto.issuerId !== autoIssuerId)
                        return acc;
                    return __spreadArray(__spreadArray([], acc, true), [curr], false);
                }, []), hasProgressiveResult: hasProgressiveResult, isSuccess: isSuccess });
        },
    }), currentPlan = _d.currentPlan, footerContent = _d.footerContent, mixedResults = _d.mixedResults, impressionId = _d.impressionId, homeResults = _d.homeResults, hasProgressiveResult = _d.hasProgressiveResult, isSuccess = _d.isSuccess;
    var headerText = useResultsHeaderText();
    var monthlyAutoPremium = getMonthlyAutoPremium(currentPlan);
    var totalMonthlyCostCents = (monthlyAutoPremium || 0) + ((currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.homeMonthlyPremiumCents) || 0);
    var cheapestBundle = homeResults === null || homeResults === void 0 ? void 0 : homeResults.reduce(function (acc, curr) {
        if (!(curr === null || curr === void 0 ? void 0 : curr.averageMonthlySavingsCents))
            return acc;
        if (!(acc === null || acc === void 0 ? void 0 : acc.averageMonthlySavingsCents))
            return curr;
        return (curr === null || curr === void 0 ? void 0 : curr.averageMonthlySavingsCents) > (acc === null || acc === void 0 ? void 0 : acc.averageMonthlySavingsCents)
            ? curr
            : acc;
    }, homeResults[0]);
    var sawSavings = ((cheapestBundle === null || cheapestBundle === void 0 ? void 0 : cheapestBundle.averageMonthlySavingsCents) || 0) > 0;
    var showBundles = impressionType === ImpressionType.AutoHome;
    var hasResults = showBundles
        ? Boolean(homeResults === null || homeResults === void 0 ? void 0 : homeResults.length)
        : Boolean(mixedResults === null || mixedResults === void 0 ? void 0 : mixedResults.length);
    useEffectOnceWhen(function () {
        sawImpression(__assign(__assign({}, commonAnalyticsProperties), { impressionRequest: {
                hasLinkedAccount: accountLinked.home,
                insuranceType: "home",
                forceFormat: "",
                medium: "online",
            }, impression: {
                insuranceType: "home",
                format: "",
                searchedProductTypes: [],
            } }));
    }, insuranceProduct !== InsuranceProducts.AutoHome);
    useEffectOnceWhen(function () {
        var filteredHomeAds = filterAdResultsForAnalytics(mixedResults);
        var homeAds = impressionType === ImpressionType.AutoHome
            ? homeResults === null || homeResults === void 0 ? void 0 : homeResults.filter(function (item) { return item.home.type === ResultType.HomeAd; })
            : filteredHomeAds;
        var homeQuotes = impressionType === ImpressionType.AutoHome
            ? homeResults === null || homeResults === void 0 ? void 0 : homeResults.filter(function (item) { return item.home.type === ResultType.HomeQuote; })
            : mixedResults === null || mixedResults === void 0 ? void 0 : mixedResults.filter(function (result) { return Boolean(result.quoteContent); });
        offerPresented(__assign(__assign({}, commonAnalyticsProperties), { impressionId: impressionId, accountReferenceId: accountReferenceId, sawSavings: sawSavings, impressionType: impressionType, ads: null, quotes: null, homeAds: homeAds, homeQuotes: homeQuotes }));
    }, isSuccess);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "text-center" },
                    React.createElement("div", { className: "text-xs text-black-300" }, "Your policy"),
                    React.createElement("div", { className: "text-xs font-semibold text-black-100" }, headerText)),
                React.createElement(EditPolicyButton, { nextRoute: PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS }))),
        React.createElement(SavvyResultsUI.Root, null,
            showBundles && hasResults ? (React.createElement(SavvyResultsUI.BundleBreadcrumbs, null)) : null,
            hasResults ? (React.createElement(SavvyResultsUI.Body, { secondaryText: getSecondaryText({
                    didLink: accountLinked.home,
                    isBundle: showBundles,
                }) },
                React.createElement(SavvyResultsUI.List, null, showBundles
                    ? homeResults === null || homeResults === void 0 ? void 0 : homeResults.map(function (result, index) { return (React.createElement(HomeBundleItem, { key: result.id, result: result, index: index, impressionId: impressionId, totalMonthlyCostCents: totalMonthlyCostCents })); })
                    : mixedResults === null || mixedResults === void 0 ? void 0 : mixedResults.map(function (_a, index) {
                        var adContent = _a.adContent, quoteContent = _a.quoteContent;
                        return (React.createElement(SavvyResultsUI.ListItem, { key: index }, adContent ? (React.createElement(Ad, { ad: adContent, index: index, impressionId: impressionId || "", insuranceType: InsuranceType.Home })) : quoteContent ? (React.createElement(Quote, { quote: quoteContent, impressionId: impressionId || "", index: index, bottomContent: quoteContent.sellingPointGroups &&
                                quoteContent.sellingPointGroups.length > 0 ? (React.createElement(SellingPointGroups, { groups: quoteContent.sellingPointGroups })) : null, insuranceType: InsuranceType.Home })) : null));
                    })),
                footerContent || insuranceProduct === InsuranceProducts.Home ? (React.createElement(SavvyResultsUI.FooterContent, null,
                    "Insurance Quotes Provided by:",
                    React.createElement("br", null), (_a = footerContent === null || footerContent === void 0 ? void 0 : footerContent.agency) !== null && _a !== void 0 ? _a : "Savvy Insurance Solutions, LLC",
                    React.createElement("br", null), (_b = footerContent === null || footerContent === void 0 ? void 0 : footerContent.licenseText) !== null && _b !== void 0 ? _b : "License #3460571")) : null,
                hasProgressiveResult ? (React.createElement(SavvyResultsUI.FooterContent, null, "Progressive Home\u00AE policies are placed through Progressive Advantage Agency, Inc. with insurers affiliated with Progressive and with unaffiliated insurers")) : null)) : (React.createElement(NoQuotes, null)),
            React.createElement(SavvyResultsUI.Footer, null))));
}
